module.exports = { id: "close", url: "/build/app/img/symbols.svg#close", viewBox: "", toString: function() { return this.url; } };